package team.platforma.dictionary_presentation.model

data class AiChapterPresentation(
    val id: Long,
    val name: String
)
